import axios from "@/api/axiosInstance";
import {
  FetchCatalogCategoriesRequest,
  FetchCatalogCategoriesResponse,
} from "./types";

export const fetchCatalogCategories = async (
  params: FetchCatalogCategoriesRequest,
  signal?: AbortSignal,
): Promise<FetchCatalogCategoriesResponse> => {
  const response = await axios.get<FetchCatalogCategoriesResponse>(
    "/api/private/product-catalog/categories",
    { params, signal },
  );
  return response.data;
};
